export default "__VITE_ASSET__4c7ed7cf__"